import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";

import { Colors } from "utils/colors";

import PreviewClip from "./components/previewClip";

import AudioFile from "./components/audioFile";
import TrackArtists from "./components/trackArtists";
import Contributors from "./components/contributors";
import SongWriters from "./components/songWriters";
import Lyrics from "./components/lyrics";
import ISRC from "./components/ISRC";
import PrimaryButton from "components/buttons/primary-button";
import TrackDetails from "./components/trackDetails";
import { ITrack } from "types/musicData";

interface IProps {
  data: ITrack;
  setTrack: (object: ITrack) => void;
  updateStep: () => void;
}
const Track = ({ data, setTrack, updateStep }: IProps) => {
  const {
    file: audio,
    trackDetails,
    trackArtists,
    contributors,
    songWriters,
    isrc,
    previewClip,
    lyrics
  } = data;

  const [updatedTrackDetails, setUpdatedTrackDetails] = useState(trackDetails);
  const [updatedTrackArtists, setUpdatedTrackArtists] = useState(trackArtists);
  const [updatedContributors, setUpdatedContributors] = useState(contributors);
  const [updatedSongWriters, setUpdatedSongWriters] = useState(songWriters);
  const [updatedISRC, setUpdatedISRC] = useState(isrc);
  const [updatedPreviewClip, setUpdatedPreviewClip] = useState(previewClip);
  const [updatedLyrics, setUpdatedLyrics] = useState(lyrics);

  const Save = () => {
    setTrack({
      file: audio,
      trackDetails: updatedTrackDetails,
      trackArtists: updatedTrackArtists,
      contributors: updatedContributors,
      isrc: updatedISRC,
      previewClip: updatedPreviewClip,
      lyrics: updatedLyrics
    });
    updateStep();
  };

  const CanSave = useMemo(() => {
    let hasTrackArtist = false;
    let hasTitle = false;
    let hasDate = false;
    let hasLanguage = false;

    //hasTrackArtist
    if (updatedTrackDetails?.title && updatedTrackDetails?.title?.length > 3) {
      hasTitle = true;
    }

    //has date
    if (updatedTrackDetails?.recordingYear?.length === 4) {
      hasDate = true;
    }

    //has language
    if (updatedTrackDetails?.language) {
      hasLanguage = true;
    }

    //has trackArtist
    if (
      updatedTrackArtists &&
      updatedTrackArtists.length > 0 &&
      updatedTrackArtists[0].name.length > 3
    ) {
      hasTrackArtist = true;
    }

    //all fields should be filled out to save track data
    if (hasTitle && hasTrackArtist && hasDate && hasLanguage) {
      return true;
    }

    return false;
  }, [updatedTrackArtists, updatedTrackDetails]);

  return (
    <Container>
      <TrackDetails
        data={updatedTrackDetails}
        setTrackDetails={(object) => {
          setUpdatedTrackDetails(object);
        }}
      />
      <AudioFile audio={audio} />
      <PreviewClip
        audio={audio}
        previewData={updatedPreviewClip || { startTime: 0, endTime: 30 }}
        setPreviewData={(data) => setUpdatedPreviewClip(data)}
      />
      <TrackArtists
        data={updatedTrackArtists}
        setTrackArtists={(data) => {
          setUpdatedTrackArtists(data);
        }}
      />
      <Contributors
        data={updatedContributors}
        setTrackArtists={(data) => setUpdatedContributors(data)}
      />
      {/* <SongWriters
        data={updatedSongWriters}
        setTrackWriters={(data) => setUpdatedSongWriters(data)}
      /> */}
      <Lyrics data={updatedLyrics} setData={(data) => setUpdatedLyrics(data)} />
      <ISRC
        data={updatedISRC || "USRC17607839"}
        setData={(data) => setUpdatedISRC(data)}
      />
      <SaveContainer>
        <SaveButton>
          <PrimaryButton text="Save" onClick={Save} disabled={!CanSave} />
        </SaveButton>
      </SaveContainer>
    </Container>
  );
};

export default Track;

const Container = styled.div``;

const SaveContainer = styled.div`
  margin-top: 5rem;
  width: 100%;
  padding: 1.4rem 6.4rem;
  padding-bottom: 0;
  border-top: 1px solid ${Colors.grey700};
  @media only screen and (max-width: 769px) {
    padding: 2.4rem;
  }
`;

const SaveButton = styled.div`
  width: 10rem;
  margin-left: auto;
`;
